import React, { useState } from 'react';
import {
	Button,
	Card,
	CardContent,
	CardHeader,
	CardMedia,
	Divider,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Typography,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import bytesToHumanReadable from 'lib/bytesToHumanReadable';
import useStyles from './FileGrid.styles';
import api from 'api';
import { enqueueSnackbar } from 'notistack';



const FileCard = ({ file, selectActions }) => {
	const classes                         = useStyles(),
		  [ menuOptions, setMenuOptions ] = useState({
			  anchor: null,
			  file_id: null,
		  });

	const [ loading, setLoading ] = useState(false);
	const [ deleted, setDeleted ] = useState(false);

	const handleMenuClose = () => {
		setMenuOptions({
			anchor: null,
			file_id: null,
		});
	};

	const handleMenuOpen = fileID => (e) => {
		setMenuOptions({
			anchor: e.currentTarget,
			file_id: fileID,
		});
	};

	const handleDelete = async () => {
		setLoading(true);
		try {
			await api.delete(`/files/${file.file_id}`);
			setDeleted(true);
			enqueueSnackbar(`File deleted`, {
				variant: 'success',
				autoHideDuration: 1500,
			});
		} catch(err) {
			enqueueSnackbar(`Error deleting file`, {
				variant: 'success',
				autoHideDuration: 1500,
			});
			setLoading(false);
		} finally {
			setLoading(false);
			setDeleted(true);
		}
		handleMenuClose();
	};

	const undoDelete = async () => {
		setLoading(true);
		try {
			await api.patch(`/files/restore`, { file_id: file.file_id });
			setDeleted(false);
			enqueueSnackbar(`File restored`, {
				variant: 'success',
				autoHideDuration: 1500,
			});
		} catch(err) {
			enqueueSnackbar(`Unable to restore file`, {
				variant: 'error',
				autoHideDuration: 1500,
			});
		} finally {
			setLoading(false);
		}
	};

	console.log({ deleted });

	return (
		<Grid item xs={3} key={file.file_id}>

			{deleted &&
				<Card className={classes.root}>
					<CardContent>
						<Typography
							noWrap
							variant="body2"
							color="textPrimary"
							style={{ whiteSpace: 'pre-wrap' }}
						>
							{`${file.file_name}.${file.file_extension}`} deleted. If the file was used in any reports,
							it may continue to appear in existing reports for up to 30 days.
						</Typography>
						<Typography variant="body2" color="textSecondary" component="div">
							<Button onClick={undoDelete} disabled={loading}>Undo</Button>
						</Typography>
					</CardContent>
				</Card>
			}

			{!deleted && <>
				<Card className={classes.root}>
					<CardHeader
						action={
							<IconButton onClick={handleMenuOpen(file.file_id)} size="large">
								<MoreVert />
							</IconButton>
						}
						subheader={file.date_created}
					/>
					<CardMedia
						className={classes.media}
						image={file.thumbnail_url}
						title={`${file.file_name}.${file.file_extension}`}
						onClick={handleMenuOpen(file.file_id)}
					/>
					<CardContent>
						<Typography
							noWrap
							variant="body2"
							color="textPrimary"
							style={{ whiteSpace: 'pre-wrap' }}
						>
							{`${file.file_name}.${file.file_extension}`}
						</Typography>
						<Typography variant="body2" color="textSecondary" component="p">
							{bytesToHumanReadable(file.file_size)}
						</Typography>
					</CardContent>
				</Card>

				<Menu
					anchorEl={menuOptions.anchor}
					open={menuOptions.file_id === file.file_id}
					onClose={handleMenuClose}
				>
					{selectActions.map(action => (
						<MenuItem
							onClick={() => {
								action.handler(file);
								handleMenuClose();
							}}
							key={action.name}
							disabled={loading}
						>
							{action.label}
						</MenuItem>
					))}
					{selectActions.length > 0 && <Divider />}
					<MenuItem
						onClick={() => {
							navigator.clipboard.writeText(file.file_url);
							handleMenuClose();
						}}
						disabled={loading}
					>
						Copy Address
					</MenuItem>
					<MenuItem onClick={handleMenuClose} disabled={loading}>Rename</MenuItem>
					<MenuItem onClick={handleDelete} disabled={loading}>Delete</MenuItem>
				</Menu>
			</>
			}
		</Grid>
	);
};

export default FileCard;
